import { useState } from "react";
import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/Reveal";
import { CTAButton } from "@/components/CTAButton";
import { PROJECTS } from "@/data/content";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "residential", label: "Residential" },
  { key: "commercial", label: "Commercial" },
];

export default function Portfolio() {
  const [filter, setFilter] = useState("all");
  const items = filter === "all" ? PROJECTS : PROJECTS.filter((p) => p.category === filter);

  return (
    <div>
      <section className="container-x pt-36 md:pt-44 pb-12 md:pb-16">
        <Overline className="mb-6">Portfolio</Overline>
        <h1 className="font-display text-5xl md:text-7xl lg:text-[6rem] font-extrabold leading-[0.9] tracking-tighter uppercase max-w-4xl">Selected<br />Works</h1>
        <p className="mt-8 text-lg md:text-xl font-light text-taupe max-w-2xl leading-relaxed">A curated survey of residential and commercial surfaces delivered across Perth and Regional WA.</p>
      </section>

      {/* Filters */}
      <div className="container-x mb-12 flex gap-8 border-b border-black/10 pb-4" data-testid="portfolio-filters">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            data-testid={`portfolio-filter-${f.key}`}
            onClick={() => setFilter(f.key)}
            className={`relative text-sm uppercase tracking-[0.2em] pb-2 transition-colors ${filter === f.key ? "text-charcoal" : "text-taupe hover:text-charcoal"}`}
          >
            {f.label}
            {filter === f.key && <span className="absolute -bottom-[17px] left-0 right-0 h-[2px] bg-sand" />}
          </button>
        ))}
      </div>

      {/* Masonry */}
      <section className="container-x pb-24 md:pb-32">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:_balance]" data-testid="portfolio-grid">
          {items.map((p, i) => (
            <Reveal key={p.id} className="mb-4 break-inside-avoid">
              <Link to={`/portfolio/${p.id}`} data-testid={`portfolio-item-${p.id}`} className="group block relative overflow-hidden">
                <img src={p.image} alt={p.title} className={`w-full object-cover transition-transform duration-[800ms] group-hover:scale-105 ${i % 3 === 0 ? "aspect-[3/4]" : i % 3 === 1 ? "aspect-square" : "aspect-[4/5]"}`} />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 p-6 text-white translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                  <div className="text-[0.65rem] uppercase tracking-[0.2em] text-sand mb-1">{p.finish} · {p.category}</div>
                  <div className="font-display text-2xl font-bold">{p.title}</div>
                  <div className="text-sm text-white/70 font-light">{p.location}</div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-offwhite py-24 md:py-32 text-center" data-testid="portfolio-cta">
        <div className="container-x">
          <Overline className="mb-6 justify-center">Your Space Next</Overline>
          <h2 className="font-display text-4xl md:text-6xl font-extrabold mb-10">Start Your Project</h2>
          <CTAButton to="/contact" testid="portfolio-cta-button" variant="primary">Get a Free Quote</CTAButton>
        </div>
      </section>
    </div>
  );
}
